import { graphql } from '../../../graphql/generated';

export const CREATE_PROFILE_MUTATION = graphql(`
  mutation CreateProfile($input: ProfileInput!) {
    createProfile(input: $input) {
      id
    }
  }
`);

export const UPDATE_PROFILE_MUTATION = graphql(`
  mutation UpdateProfile($id: ID!, $input: ProfileInput!) {
    updateProfile(id: $id, input: $input) {
      id
    }
  }
`);
